declare global {
    interface Window {
        Moengage: any;
    }
}

/**
 * Check if MoEngage is available and loaded
 */
const isMoEngageAvailable = (): boolean => {
    return typeof window !== 'undefined' && window.Moengage;
};

/**
 * Identify user with MoEngage (call this when user logs in)
 */
export const identifyMoEngageUser = (user: {
    id: string | number;
    name?: string;
    email?: string;
    phone?: string;
    gender?: string;
    birthday?: string; // Format: YYYY-MM-DD
    [key: string]: any;
}) => {
    if (!isMoEngageAvailable()) {
        console.warn('MoEngage not available');
        return;
    }

    try {
        // Set unique user ID (required)
        window.Moengage.identifyUser(user.id.toString());
        
        // Add user attributes
        if (user.name) window.Moengage.add_user_name(user.name);
        if (user.email) window.Moengage.add_email(user.email);
        if (user.phone) window.Moengage.add_mobile(user.phone);

        console.log('MoEngage user identified:', user.id);
    } catch (error) {
        console.error('MoEngage identify user error:', error);
    }


};

/**
 * Update user unique ID (if needed)
 */
export const updateMoEngageUserId = (newUserId: string | number) => {
    if (!isMoEngageAvailable()) {
        console.warn('MoEngage not available');
        return;
    }

    try {
        window.Moengage.update_unique_user_id(newUserId.toString());
        console.log('MoEngage user ID updated:', newUserId);
    } catch (error) {
        console.error('MoEngage update user ID error:', error);
    }
};

/**
 * Destroy MoEngage session (call on logout)
 */
export const destroyMoEngageSession = () => {
    if (!isMoEngageAvailable()) {
        console.warn('MoEngage not available');
        return;
    }

    try {
        window.Moengage.destroy_session();
        console.log('MoEngage session destroyed');
    } catch (error) {
        console.error('MoEngage destroy session error:', error);
    }
};
